module.exports = __webpack_public_path__ + "01ea978f/img/copy-icon.408fdb2d.svg";